<template>
	<div class="modal fade bd-example-modal-xl" id="modal-relatorio">
		<div class="modal-dialog modal-xl" role="document">
			<div class="modal-content">

				<div class="modal-header">
					<h5 class="modal-title" id="exampleModalLabel">Novo relatório</h5>
					<button type="button" class="close" data-dismiss="modal" aria-label="Fechar">
						<span aria-hidden="true">&times;</span>
					</button>
				</div>

				<div class="modal-body">
					<div class="form-group">
		                <label  for="titulo">Título</label>
		                <input type="text" class="form-control form-control-sm" placeholder="Informe um título para o relatório." v-model="relatorio.titulo">
		            </div>

		            <tinymce-editor v-model="relatorio.corpo" api-key="tiny_key" :init="editor_init" ref="tinymce"></tinymce-editor>
				</div>

				<div class="modal-footer">
					<button type="button" class="btn btn-sm btn-danger" data-dismiss="modal">Cancelar</button>

					<button v-if="relatorio.id" class="btn btn-sm btn-success" @click="update">Atualizar</button>
					<button v-else 				class="btn btn-sm btn-success" @click="save">Salvar</button>

					<button class="btn btn-sm btn-info" @click="create_pdf">Gerar PDF</button>
				</div>

			</div>
		</div>

		<denuncia @select="insert_audio" />
	</div>
</template>

<script>
	import editor   from '@tinymce/tinymce-vue'
	import denuncia from './buscaAudio'
	import api 		from "@/mixins/api.js"
	import elements	from "@/mixins/elements.js"

    export default {
    	name: "modal-relatorio",
    	mixins: [api, elements],
    	props: ["relatorio"],

    	data: () => { return {
    		tiny_key: "obuuuntkbdjgnpjd89rzjuw9saxg2fx04s1m472fh0l6ttxy",
    	}},

    	components: { 'tinymce-editor': editor, denuncia },

		methods: {
			create_pdf() {
				this.$emit('create_pdf', this.relatorio.id)
			}, 

			async save() {
				this.relatorio.type    = 1
				this.relatorio.autor   = this.$store.state.user.id
				this.relatorio.unidade = this.$store.state.user.unidade_id

				const response = await this.POST('Relatorio', this.relatorio)
				this.$emit('alert', response)
			},

			async update() {
				const response = await this.PUT('Relatorio', this.relatorio)
				this.$emit('alert', response)
			},

			async insert_audio(payload) {
				
				// CABEÇALHO
				//const cabecalho = document.createElement('h3')
				//cabecalho.style.cssText = "width: 100%; text-align: center;"
				//cabecalho.innerText = "GRAVAÇÃO"

				const cabecalho = document.createElement('span')
				cabecalho.style.cssText = "text-align: center; font-size: 18pt;"
				if(payload.gravacao.canal == 1){
					cabecalho.innerText = this.$store.state.config_view_menu.denuncia_detalhe+" Por Telefone"
				}

				if(payload.gravacao.canal == 2){
					cabecalho.innerText = this.$store.state.config_view_menu.denuncia_detalhe+" Por Site"
				}
				
				//	TABELA COM INFORMAÇÕES DO ÁUDIO
				const thead = this.create_row(['ID', 'PROTOCOLO', 'ORIGEM', 'DATA', 'HORA'])
				const tbody = this.create_row([
					payload.gravacao.id, 
					payload.gravacao.protocolo, 
					payload.gravacao.origem, 
					this.$moment(payload.gravacao.created_at).format("DD/MM/YYYY"), 
					this.$moment(this.convert_hor(payload.gravacao.created_at)).format("HH:mm:ss")
				])
				const table = this.create_table([thead, tbody])

				//	CRIA DIV COM TODO O CONTEÚDO
				const gravacao = document.createElement('div')
				gravacao.appendChild(cabecalho)
				gravacao.appendChild(document.createElement('br'))
				gravacao.appendChild(table)
				if ( payload.show_analise || payload.show_transcricao )
					if(payload.gravacao.canal == 2){
							var div = document.createElement('div')
							var titulo_denuncia = document.createElement('span')
							titulo_denuncia.style.cssText = "text-align: center; font-size: 18pt;"				
							titulo_denuncia.innerText = this.$store.state.config_view_menu.denuncia_detalhe
							gravacao.appendChild(div.appendChild(document.createElement('br')))
							gravacao.appendChild(div.appendChild(titulo_denuncia))
							var transcricao = this.create_blockquote({ title: "", content: payload.gravacao.denuncia })
							gravacao.appendChild(div.appendChild(transcricao))
							gravacao.appendChild(div.appendChild(document.createElement('br')))
					}else{
						gravacao.appendChild( await this.insert_blockquote(payload) )
					}

				//	INSETRE CONTEÚDO NO TINYMCE
				this.$refs.tinymce.editor.insertContent(gravacao.outerHTML)
			},

			async insert_blockquote(payload) {
				const div = document.createElement('div')

				const response = await this.GET('Denuncia/Historico', payload.gravacao.last_action)
				
				if ( response.status == "success" )
				{
					if ( payload.show_analise ) {
						var titulo_analise = document.createElement('span')
						titulo_analise.style.cssText = "text-align: center; font-size: 18pt;"				
						titulo_analise.innerText = "Análise"
						div.appendChild(titulo_analise)
						const analise = this.create_blockquote({ title: "", content: response.result.analise })
						div.appendChild(analise)
					}
 
					if ( payload.show_transcricao ) {
						var titulo_transcricao = document.createElement('span')
						titulo_transcricao.style.cssText = "text-align: center; font-size: 18pt;"				
						titulo_transcricao.innerText = "Transcrição"
						div.appendChild(titulo_transcricao)
						const transcricao = this.create_blockquote({ title: "", content: response.result.transcricao })
						div.appendChild(transcricao)
					}
				}

				return div
			},

			convert_hor(payload){
				var nova_hora = new Date(payload);
				nova_hora.setHours(nova_hora.getHours()-3);
				return nova_hora;
			},

			montarData(){
				const meses = new Array("Janeiro","Fevereiro","Março","Abril","Maio","Junho","Julho","Agosto","Setembro","Outubro","Novembro","Dezembro");

				const hoje = new Date();
				const dia  = hoje.getDate();
				const mes  = hoje.getMonth();
				const ano  = hoje.getYear() + 1900;

				return dia + ' de ' + meses[mes] + ' de ' + ano;
			}
		},

    	computed: {
			editor_init() { return {
				selector: 'textarea#relatorio',
				height: $( document ).height() * 0.6,
				plugins: "autolink lists link image charmap print fullscreen table paste",

				toolbar: "fullscreen | undo redo | table image charmap | btn_add | styleselect fontselect fontsizeselect | bold italic forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent",
				statusbar:  false,
				menubar:    false,
				browser_spellcheck : true,
				paste_data_images: true,
				save_enablewhendirty: true,

				content_css: [
				'//fonts.googleapis.com/css?family=Lato:300,300i,400,400i',
				'//www.tiny.cloud/css/codepen.min.css'],

				setup: editor => {
					const toggleState = false;

					editor.ui.registry.addMenuButton('btn_add', {
						text: 'Adicionar',

						fetch: calback => {
							const textOptions = [
								{
									type: 'menuitem',
									text: 'Relatório',
									onAction: () => editor.insertContent(this.$store.state.config.relatorio_txt_relatorio)
								},

								{
									type: 'menuitem',
									text: 'Destinatário',
									onAction: () => editor.insertContent(this.$store.state.config.relatorio_txt_destinatario)
								},

								{
									type: 'menuitem',
									text: 'Referente',
									onAction: () => editor.insertContent(this.$store.state.config.relatorio_txt_referente)
								},

								{
									type: 'menuitem',
									text: 'Data',
									onAction: () => editor.insertContent(`<p style='text-align: right;'>${this.montarData()}</p>`)
								},

								{
									type: 'menuitem',
									text: 'Assinatura',
									onAction: () => editor.insertContent(this.$store.state.config.relatorio_txt_assinatura)
								},
							];

							const itens = [
								//
							    //		ADICIONAR DENÚNCIA
							    //_________________________________________________________________
								{
									type: 'menuitem',
									text: this.$store.state.config_view_menu.denuncia_detalhe,
									onAction: () => $("#buscarDenuncia").modal()
								},

								//
							    //		MENU PREENCHIMENTO DE DOCUMENTO
							    //_________________________________________________________________
								{
									type: 'menuitem',
									text: 'Texto',
									getSubmenuItems: () => textOptions
								}
							];

							calback(itens);
						}
					});
			  	}
			}}
		}
    }
</script>

<style scoped>
</style>
